import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { List, Map } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import {
    FHEContainerForm,
    FHEContainerScroll,
    FHETitle,
    FHETextField,
    FormEditButton,
    FHECheckbox,
    FormSaveButton,
    FHEButton,
    FHEReactSelect
} from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { SvgCraftsman } from 'data/common/iconsvg';
import memoizeOne from 'memoize-one';

class FormCraftsman extends PureComponent {
    static propTypes = {
        managementsArray: PropTypes.array.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        resetPassword: PropTypes.func,
        sendDataFunc: PropTypes.func.isRequired,
        craftsman: PropTypes.object.isRequired,
        renderOtherChildren: PropTypes.func,
        type: PropTypes.string.isRequired,
        managements: PropTypes.array
    };

    static defaultProps = {
        renderOtherChildren: null,
        resetPassword: null,
        managements: []
    };

    constructor(props) {
        super(props);
        const { type } = props;

        this.state = {
            passwordReseting: false,
            provisionningBox: false,
            formDisabled: type === 'update',
            craftsmanForm: this.getDataForm(),
            textInput_error: {},
            sendLoading: false
        };
    }

    getDataForm = () => {
        const { type, craftsman } = this.props;
        return {
            label: type === 'update' ? craftsman.get('label') : null,
            firstname: type === 'update' ? craftsman.get('firstname') : null,
            lastname: type === 'update' ? craftsman.get('lastname') : null,
            craftsmanType: type === 'update' ? craftsman.get('craftsmanType') : null,
            isActive: type === 'update' ? !!craftsman.get('isActive') : null,
            email: type === 'update' ? craftsman.get('email') : null,
            telPort: type === 'update' ? craftsman.get('telPort') : null,
            telFixe: type === 'update' ? craftsman.get('telFixe') : null,
            managements: type === 'update' ? craftsman.getIn(['managementIds'], new List()).toArray() : null
        };
    };

    getCraftsmanManagements = () => {
        const { craftsman, managements } = this.props;
        const managemementIds = craftsman.getIn(['managementIds'], new Map());
        let craftsmanManagements = [];
        managemementIds.map(managementId => {
            managements.forEach((management, mkey) => {
                if (parseInt(managementId) === parseInt(management.id)) {
                    craftsmanManagements.push(managements[mkey].id);
                }
            });
        });

        return craftsmanManagements;
    };

    getSelectedManagements = memoizeOne(managementIds => {
        const { managements } = this.props;

        if (managementIds) {
            return managementIds.reduce((reduction, value) => {
                const management = managements.getIn([value.toString()], new Map());
                return [...reduction, { value, label: management.get('libelle') }];
            }, []);
        }
    });

    loadInputs = () => {
        this.setState({
            formDisabled: true,
            sendLoading: false,
            craftsmanForm: this.getDataForm()
        });
    };

    handleEdit = () => {
        const { formDisabled, provisionningBox } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabled: formDisabled && provisionningBox ? true : !formDisabled,
            provisionningBox: false,
            textInput_error: {}
        });
    };

    handleChange = event => {
        const { craftsmanForm, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        const fieldLengthRules = {
            label: 255,
            firstname: 255,
            lastname: 255,
            craftsmanType: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = craftsmanForm[event.target.name];
        this.setState({
            craftsmanForm: { ...craftsmanForm, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    handleFormError = fields => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        return this.setState({
            textInput_error: res
        });
    };

    formatForm = () => {
        const { craftsmanForm } = this.state;
        const { type } = this.props;
        let form = craftsmanForm;
        Object.keys(form).forEach(key => {
            if (form[key] === '') {
                form[key] = null;
            }
            if (type === 'add' && key === 'isActive') {
                form[key] = true;
            }
        });
        this.setState({
            craftsmanForm: form
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    confirmEdit = () => {
        const { craftsmanForm } = this.state;
        const { sendDataFunc, history } = this.props;
        this.formatForm();
        if (this.validateForm(craftsmanForm)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });
            return sendDataFunc(craftsmanForm)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.craftsman.actions.editCraftsmanSuccess`, craftsmanForm.label));
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        provisionningBox: false,
                        sendLoading: false
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(
                        Translator.translateWithFallback(
                            `api.message.${error.message}`,
                            `generic.Craftsman.actions.editCraftsmanError`,
                            craftsmanForm.label
                        )
                    );
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate(`generic.craftsman.actions.editCraftsmanError`, craftsmanForm.label)
                        );
                    }
                });
        }
    };

    askResetPassword = e => {
        const { craftsmanForm } = this.state;
        e.preventDefault();
        Toastr.confirm(
            Translator.translate('generic.craftsman.actions.confirmResetPassword', craftsmanForm.label),
            Translator.translate('generic.craftsman.actions.resetPasswordTitle'),
            {
                onYes: this.resetPassword
            }
        );
    };

    resetPassword = () => {
        const { resetPassword } = this.props;
        const { craftsmanForm } = this.state;

        this.setState({
            passwordReseting: true
        });

        return resetPassword(craftsmanForm)
            .then(() => {
                Toastr.success(Translator.translate('generic.craftsman.actions.resetPasswordSuccess', craftsmanForm.label));
            })
            .catch(() => {
                Toastr.error(Translator.translate('generic.craftsman.actions.resetPasswordError', craftsmanForm.label));
            })
            .finally(() => {
                this.setState({
                    passwordReseting: false
                });
            });
    };

    saveCraftsman = () => {
        const { craftsmanForm } = this.state;
        const { sendDataFunc, history, profile } = this.props;

        this.formatForm();

        if (this.validateForm(craftsmanForm)) {
            this.setState({
                formDisabled: true,
                sendLoading: true
            });
            return sendDataFunc(craftsmanForm)
                .then(data => {
                    const craftsman = data.craftsman;
                    Toastr.success(Translator.translate('generic.craftsman.actions.addCraftsmanSuccess', craftsman.lastname, craftsman.firstname));
                    if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('craftsmanDetails'))
                        return history.push({
                            pathname: `/${history.environment}/craftsman/detail/${data.craftsmanId}`,
                            state: { fromAdd: true }
                        });
                    return history.push(`/${history.environment}/craftsman`);
                })
                .catch(error => {
                    Toastr.error(Translator.translate('generic.craftsman.actions.addCraftsmanError', craftsmanForm.label));
                    this.setState({
                        formDisabled: false,
                        sendLoading: false
                    });
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors);
                    }
                });
        }
    };

    validateForm(form) {
        const errors = {};
        const regexTel = RegExp(/^(\+[1-9]{2}\s|0)([1-9])((\s|\.|-)?\d{2}){4}$/);

        if (this.isEmpty(form.label)) {
            errors['label'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.firstname)) {
            errors['firstname'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.lastname)) {
            errors['lastname'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.email)) {
            errors['email'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.telPort) && this.isEmpty(form.telFixe)) {
            errors['telPort'] = Translator.translate('general.fields.error.any.empty');
            errors['telFixe'] = Translator.translate('general.fields.error.any.empty');
        }
        if (!this.isEmpty(form.telPort) && !regexTel.test(form.telPort)) {
            errors['telPort'] = Translator.translate('general.fields.error.string.regex.base');
        }
        if (!this.isEmpty(form.telFixe) && !regexTel.test(form.telFixe)) {
            errors['telFixe'] = Translator.translate('general.fields.error.string.regex.base');
        }

        if (this.isEmpty(form.isActive)) {
            errors['isActive'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.craftsmanType)) {
            errors['craftsmanType'] = Translator.translate('general.fields.error.any.empty');
        }
        if (form.managements.length < 1) {
            errors['managements'] = Translator.translate('general.fields.error.array.min');
        }

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    }

    renderButtonsForm() {
        const { formDisabled, sendLoading, provisionningBox } = this.state;
        const { profile, type, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        if (type === 'update') {
            if (profile.get('admin') || userRights.includes('craftsmanDetailsUpdate'))
                return (
                    <FormEditButton
                        formDisabled={formDisabled && !provisionningBox}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                    />
                );
        } else if (profile.get('admin') || userRights.includes('craftsmanAdd'))
            return <FormSaveButton sendFunc={this.saveCraftsman} sendLoading={sendLoading} />;
    }

    handleReactSelect = (event, options) => {
        const { craftsmanForm, textInput_error } = this.state;

        const newTextInput_error = tools.removeKey(textInput_error, options.name);

        if (options.name === 'managements') {
            this.setState({
                craftsmanForm: {
                    ...craftsmanForm,
                    managements: event ? event.map(home => home.value) : null
                },
                textInput_error: newTextInput_error
            });
        } else {
            this.setState({
                craftsmanForm: { ...craftsmanForm, [options.name]: event.value },
                textInput_error: newTextInput_error
            });
        }
    };

    render() {
        const { textInput_error, formDisabled, craftsmanForm, passwordReseting } = this.state;
        const { managementsArray, profile, type, renderOtherChildren, craftsman, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        const deactivationCraftsmanRights = profile.get('admin') || userRights.includes('craftsmanDeactivation');
        const resetPasswordRights = profile.get('admin') || userRights.includes('craftsmanResetPassword');

        return (
            <Fragment>
                <FHETitle title={type === 'update' ? craftsman.get('label') : Translator.translate('general.addCraftsman')} Icon={SvgCraftsman} />
                {this.renderButtonsForm()}
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="label"
                                    value={craftsmanForm.label}
                                    error={textInput_error.label}
                                    label={Translator.translate('general.table.column.label')}
                                    name="label"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="firstname"
                                    value={craftsmanForm.firstname}
                                    error={textInput_error.firstname}
                                    label={Translator.translate('general.table.column.firstname')}
                                    name="firstname"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="lastname"
                                    value={craftsmanForm.lastname}
                                    error={textInput_error.lastname}
                                    label={Translator.translate('general.table.column.lastname')}
                                    name="lastname"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="email"
                                    value={craftsmanForm.email}
                                    error={textInput_error.email}
                                    label={Translator.translate('general.table.column.email')}
                                    name="email"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="telPort"
                                    value={craftsmanForm.telPort ? craftsmanForm.telPort : ''}
                                    error={textInput_error.telPort}
                                    label={Translator.translate('general.table.column.telPort')}
                                    name="telPort"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="telFixe"
                                    value={craftsmanForm.telFixe ? craftsmanForm.telFixe : ''}
                                    error={textInput_error.telFixe}
                                    label={Translator.translate('general.table.column.telFixe')}
                                    name="telFixe"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="craftsmanType"
                                    value={craftsmanForm.craftsmanType}
                                    error={textInput_error.craftsmanType}
                                    label={Translator.translate('general.table.column.craftsmanType')}
                                    name="craftsmanType"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            {type === 'update' && (
                                <Fragment>
                                    <Grid container item sm={12} md={6} lg={4}>
                                        <FHECheckbox
                                            disabled={!deactivationCraftsmanRights || formDisabled}
                                            checked={!!craftsmanForm.isActive}
                                            label={Translator.translate('general.table.column.isActive')}
                                            value="isActive"
                                            onChange={this.handleChange}
                                        />
                                    </Grid>
                                    {resetPasswordRights && (
                                        <Grid container item sm={12} md={6} lg={4}>
                                            <FHEButton
                                                content={Translator.translate('generic.user.actions.resetPassword')}
                                                clickFunction={this.askResetPassword}
                                                loading={passwordReseting}
                                            />
                                        </Grid>
                                    )}
                                </Fragment>
                            )}

                            <Grid container item sm={12}>
                                <FHEReactSelect
                                    name="managements"
                                    label={Translator.translate('general.table.column.managements')}
                                    disabled={formDisabled}
                                    onChange={this.handleReactSelect}
                                    multiple
                                    value={this.getSelectedManagements(craftsmanForm.managements)}
                                    choices={managementsArray}
                                    error={textInput_error.managements}
                                    closeMenuOnSelect={false}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    {renderOtherChildren && renderOtherChildren()}
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const craftsman = state.environments[history.environment].data.Craftsmen.getIn(['list', props.match.params.craftsmanId], new Map());
    const managements = state.environments[history.environment].data.Managements.get('list');
    const managementsArray = managements.reduce((acc, management, key) => [...acc, { value: parseInt(key), label: management.get('libelle') }], []);
    return {
        profile: state.data.user,
        craftsman,
        managements,
        managementsArray
    };
}

export default withRouter(renderEnvComponent('scenes/Craftsman/Form/FormCraftsman', connect(mapStateToProps)(FormCraftsman)));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Craftsman/Form/FormCraftsman.js